<script>
    import ProductCard from './ProductCard.svelte';

    let productList = [
        {
            "id": "xyz123",
            "name": "Kashmiri Apple",
            "image": "../images/products/kashmiri-apple.webp",
            "imageCaption": "An Kashimiri Apple",
            "regionalName": "কাশ্মীৰী আপেল",
            "mrp" : 100,
            "offeredPrice": 80,
        },
        {
            "id": "xyz124",
            "name": "Lai Green Leaf",
            "imageCaption": "A pack of Lai Green Leaf",
            "image": "../images/products/lai-green-leaf.png",
            "regionalName": "লাই শাক",
            "mrp" : 10,
            "offeredPrice": 5,
        },

        {
            "id": "xyz125",
            "name": "Basmati Rice",
            "image": "../images/products/basmati-rice.webp",
            "imageCaption": "Basmati Rice",
            "regionalName": "বাচমতী চাউল",
            "mrp" : 200,
            "offeredPrice": 180,
        },

        {
            "id": "xyz126",
            "name": "Lux Bathing Soap",
            "image": "../images/products/lux-bathing-soap-soft-touch-150gm.jpg",
            "imageCaption": "Lux bathing soap soft touch 150gm",
            "regionalName": "লাক্স গা-ধোৱা চাবোন",
            "mrp" : 10,
            "offeredPrice": 9,
        },
        
    ];

    
</script>

<style>
    .product-list{
        display: grid;
        gap: 1rem;
        grid-template-columns: repeat( auto-fit, minmax(8rem, auto));
    }
</style>

<section>

    <h2>Popular Products</h2>

    <div class="product-list">

        {#each productList as product}
            <ProductCard
                productName='{product.name}'
                productImage='{product.image}'
                productImageCaption='{product.imageCaption}'
                productRegionalName='{product.regionalName}'
                productOfferedPrice='{product.offeredPrice}'
                productRetailPrice='{product.mrp}'
            />
        {/each}
        
    </div>

</section>
